import { render } from "./CardText.vue?vue&type=template&id=00575e90&scoped=true&ts=true"
import script from "./CardText.vue?vue&type=script&lang=ts"
export * from "./CardText.vue?vue&type=script&lang=ts"

import "./CardText.vue?vue&type=style&index=0&id=00575e90&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00575e90"]])

export default __exports__